module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580x2-5ecdfd7d5ce8df49d93bc428c2f3d1ca.jpg";